module.exports = __webpack_public_path__ + "img/order-title.b5db862d.png";